<template>
    <div>
        <p class="text-center mb-0">{{unidadeSelecionada.cnes}} - {{unidadeSelecionada.nome}}</p>
        <p class="text-center mb-0"><strong>Enfermaria:</strong> {{dados.leitoCodigoEnfermaria}} <strong>Leito:</strong> {{dados.leitoCodigo}}</p>
        <p class="text-center"><strong>{{dados.leitoNomeEnfermaria}}</strong></p>

        <div class="row">
            <div class="col form-group">
                <label for="">Paciente</label>
                <input class="form-control" :value="dados.nomePacienteReserva" disabled>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6 form-group">
                <label for="">CNS</label>
                <input class="form-control" :value="dados.cnsPacienteReserva" disabled>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6 form-group">
                <label for="">Dt. Solicitação Reserva</label>
                <input class="form-control" :value="dados.dataHoraReservaSolicitacao" disabled>
            </div>
            <div class="col-sm-6 form-group">
                <label for="">Expectativa Admissão</label>
                <input class="form-control" :value="dados.dataHoraReserva" disabled>
            </div>
        </div>
        <div class="row">
            <div class="col form-group">
                <label for="">Profissional</label>
                <input class="form-control" :value="dados.nomeProfissionalReserva" disabled>
            </div>
        </div>

         <div class="row">
            <div class="col-sm-6 form-group">
                <label for="data-picker">Data da Admissão</label>
                <datepicker
                    v-model="dataSemFormatacao"
                    :format="formatoData"
                    :disabled="dateDisabled"
                    language="pt-br"
                    id="data-picker"
                    calendar-button
                    calendar-button-icon="fa fa-calendar"
                    >
                </datepicker>
            </div>

            <div class="col-sm-6 form-group">
                <label>Hora da Admissão</label>
                <input class="form-control" type="time" v-model="hora">
                <small v-if="hora == ''" class="text-danger">preenchimento obrigatório</small>
            </div>
        </div>
       
        <button type="button" class="btn btn-danger mt-2" @click.once="validaSessao('cancelarReserva')">Cancelar a Reserva</button>
        <button type="button" class="btn btn-primary mt-2 ml-2" @click.once="validaSessao('internarReserva')">Internar Paciente</button>

    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import moment from "moment"
import { validaSessao } from '../../../shared/mixins/validaSessao'

export default {
    props: {
        dados: Object
    },
    mixins: [
        validaSessao
    ],
    components: {
        Datepicker,
    },
    mounted () {
        let hora = new Date().getHours()
        let min = new Date().getMinutes()
        if (hora < 10) hora = '0' + hora
        if (min < 10) min = '0' + min
        
        this.hora = hora + ':' +  min
    },
     data () {
        return {
           hora: '',
            dataSemFormatacao: new Date(),
            hora: '',
            formatoData: 'dd/MM/yyyy',
            dateDisabled: {
                to: new Date(new Date().setDate(new Date().getDate()-30)),
                from: new Date()
            },
        }
    },
    computed: {
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        },
    },
    methods: {
        formatadata (date) {
            return moment(date).format("YYYY-MM-DD")
        },
        cancelarReserva () {
            let dados = {
                codigoEnfermaria: this.dados.leitoCodigoEnfermaria,
                codigoLeito: this.dados.leitoCodigo,
                sexo: this.sexo
            }
  
            this.$emit('cancelar', dados)
        },
        internarReserva () {
            if (this.hora == '') return
            let datahora = this.formatadata(this.data_internacao_semformatacao) + ' ' + this.hora

            let dados = {
                cns: this.dados.cnsPacienteReserva,
                codigoEnfermaria: this.dados.leitoCodigoEnfermaria,
                codigoLeito: this.dados.leitoCodigo,
                dataHoraInternacao: datahora
            }
  
            this.$emit('internar', dados)
        }
    }
}
</script>